module.exports = __webpack_public_path__ + "img/item_card_icon.0ea90e6a.svg";